import React from "react";
import { Container, Row, Col } from "react-bootstrap";
import ProjectCard from "./ProjectCards";
import Particle from "../Particle";
import urlshortner from "../../Assets/Projects/urlshortner.jpeg";
import railway from "../../Assets/Projects/railway.webp";
import chatify from "../../Assets/Projects/chatify.png";
import learntube from "../../Assets/Projects/learntube.png";
import comment from "../../Assets/Projects/comment.png";
import blog from "../../Assets/Projects/blog.webp";
import mytrain from "../../Assets/Projects/mytrain.jpg";
import musicly from "../../Assets/Projects/musically.jpg";
import kubernetes from "../../Assets/Projects/kubernetes.jpg";
import eks from "../../Assets/Projects/eks.png";
import jenkins from "../../Assets/Projects/jenkins.png";

function Projects() {
  return (
    <Container fluid className="project-section">
      <Particle />
      <Container>
        <h1 className="project-heading">
          My Recent <strong className="purple">Works </strong>
        </h1>
        <p style={{ color: "white" }}>
          Here are a few projects I've worked on.
        </p>
        <Row style={{ justifyContent: "center", paddingBottom: "10px" }}>
          <Col md={4} className="project-card">
            <ProjectCard
              imgPath={jenkins}
              isBlog={false}
              title="Auto deployment using Jenkins"
              description="This pipeline-based project used a webhook to connect Jenkins and Github. automatically rebuilds and deploys your application after detecting the most recent push on Github. The pipeline is divided into four stages: code pull, build, test, and deploy. The pipeline is triggered by a webhook, which is connected to the Github repository. For the reusability of code and the ease of deployment, the pipeline is written in Groovy and a shared library is created."
              ghLink="https://github.com/Mukesh015/Note-App"
              demoLink="#"
            />
          </Col>
          <Col md={4} className="project-card">
            <ProjectCard
              imgPath={eks}
              isBlog={false}
              title="MERN app deployment on AWS(EKS)"
              description="In essence, the project is built on top of React, Node.js, and MongoDB (three tier). The architecture of this deployment means that we must first dockerize the frontend and backend, then push it to the Elastic Container Registry (ECR), deploy it on Kubernetes (EKS) with MongoDB, attach an ingress controller to EKS, and finally attach an Application Load Balancer (ALB) for load balancing."
              ghLink="https://github.com/Mukesh015/Three-Tier-App-Deploy"
              demoLink="#"
            />
          </Col>
          <Col md={4} className="project-card">
            <ProjectCard
              imgPath={kubernetes}
              isBlog={false}
              title="Two tier app deployment on AWS"
              description="This application was created using Flask. I used Docker and the Helm package manager to deploy this application to AWS using EKS (Elastic Kubernetes Service). It automatically builds the image and launches the most recent container after utilising a webhook to find the most recent push on Github. Every Kubernetes feature—auto scaling, auto healing, etc.—is activated. An ALB has now been bound for public access to this application."
              ghLink="https://github.com/Mukesh015/Two-Tier-App-Deployment"
              demoLink="#"
            />
          </Col>
          <Col md={4} className="project-card">
            <ProjectCard
              imgPath={mytrain}
              isBlog={false}
              title="My Train"
              description="A website that, just for Indian stations, provides extensive rail timetable search functionality. It offers live updates on all stations along the route in addition to real-time train tracking. To make sure they are aware of the travel conditions, users can check the weather for any given date at both the starting and destination points. By providing up-to-date information specifically suited for Indian railway stations, this platform aims to make planning a train trip easier and more efficient."
              ghLink="https://github.com/Mukesh015/My-Train"
              demoLink="https://my-tour-pi.vercel.app"
            />
          </Col>
          <Col md={4} className="project-card">
            <ProjectCard
              imgPath={musicly}
              isBlog={false}
              title="Musically"
              description="A feature-rich music platform offering a seamless user experience. Users can easily play, upload, download, and delete tracks. The platform provides a comprehensive music management system, allowing users to view the full list of tracks, create or delete playlists, and remove individual songs. Playlist sharing enables collaboration with friends. For a dynamic experience, users can manage music queues, adding or removing songs or deleting the queue entirely, giving them full control over their musical journey."
              ghLink="https://github.com/Mukesh015/online-music-platform"
              demoLink="https://musicly-ktbt.vercel.app "
            />
          </Col>

          <Col md={4} className="project-card">
            <ProjectCard
              imgPath={learntube}
              isBlog={false}
              title="Learntube"
              description="You can post course videos to the same course and organise your course with this programme. Users can purchase your course through the Stripe payment mechanism. You can also post videos to the public domain for free views, and subscribers will be tallied. In essence, it is a mix of YouTube and Unacademy made with numerous technologies such as Next.js, Firebase, Redux, Node (Server), Tailwind, and many more. There are 23 routes offered in total."
              ghLink="https://github.com/Mukesh015/learntube-1.0"
              demoLink="https://learntube-8cmt.onrender.com"
            />
          </Col>

          <Col md={4} className="project-card">
            <ProjectCard
              imgPath={comment}
              isBlog={false}
              title="YouTube Comment Analyzer"
              description="This Chrome extension uses an artificial intelligence (AI) sentiment analysis system built in Python. It automatically retrieves the comments and compares the counts of favourable, negative, and neutral remarks whenever it detects a YouTube video tab open in Chrome."
              ghLink="https://github.com/Mukesh015/YouTube-Comment-Analyzer"
              demoLink="#"
            />
          </Col>

          <Col md={4} className="project-card">
            <ProjectCard
              imgPath={railway}
              isBlog={false}
              title="Railway Monitoring System"
              description="This is a Python AI project based on CCTV. CCTV constantly scans the area for unlawful activity, such as smoking, odd behaviours, crowd control, and staff job monitoring. It will alert and sound the alarm if any of the above are found."
              ghLink="https://github.com/Mukesh015/Railway-monitoring-system"
              demoLink="https://vimeo.com/893119312"
            />
          </Col>

          <Col md={4} className="project-card">
            <ProjectCard
              imgPath={urlshortner}
              isBlog={false}
              title="URL Shortner"
              description="Just Paste the link and click on generate button your link will be shortened and a QR code will generated you can go with either link or QR. Authentication is implemented, your data is sheparated here, All the data will be shown as tabular form for better experience."
              ghLink="https://github.com/Mukesh015/Url-Shortner-2.0"
              demoLink="https://url-shortner-xgln.onrender.com/"
            />
          </Col>

          <Col md={4} className="project-card">
            <ProjectCard
              imgPath={blog}
              isBlog={false}
              title="Blog Application"
              description="Once a person has authenticated, they can post questions and receive responses from knowledgeable individuals. Here, a stunning user interface is used, along with a dashboard that shows the chronological order of all questions and the number of responders. People can view all of the suggested blogs relevant to their interests under the blog tab. To regulate traffic, Next.js, Tailwind, Redux, Node Server, and Nginx were used in its creation."
              ghLink="https://github.com/Mukesh015/Blog-Application"
              demoLink="https://communityblog.onrender.com"
            />
          </Col>
          <Col md={4} className="project-card">
            <ProjectCard
              imgPath={chatify}
              isBlog={false}
              title="Chatify"
              description="Personal Chat Room or Workspace to share resources and hangout with friends build with Next.js, Material-UI, and Firebase. Have features which allows user for realtime messaging, image sharing as well as supports reactions on messages as like google meet."
              ghLink="https://github.com/Mukesh015/Videocall-Application"
              demoLink="#"
            />
          </Col>
        </Row>
      </Container>
    </Container>
  );
}

export default Projects;
